/**
 * Get the appliation currency.
 */
import { createSelector } from 'reselect';
import { offsetCategories } from '/business/shared/util/Statics';

import getApplicationOffsetPercentageSelector from './getApplicationOffsetPercentageSelector';

export default createSelector([getApplicationOffsetPercentageSelector], (offsetPercentage = null) => {
  if (typeof offsetPercentage !== 'number') {
    return null;
  }
  if (offsetPercentage <= 0) {
    return offsetCategories.NO_OFFSET;
  }
  if (offsetPercentage >= 100) {
    return offsetCategories.ALL_OFFSET;
  }
  if (offsetPercentage > 0 && offsetPercentage < 100) {
    return offsetCategories.SOME_OFFSET;
  }
  return null;
});
